export const DETAIL_PLACEHOLDER = '—';

export const isMissingDetailValue = (value: unknown): boolean =>
  value === undefined ||
  value === null ||
  value === '' ||
  (typeof value === 'number' && Number.isNaN(value));

export function formatPlantDetail<T>(
  value: T,
  format: (value: NonNullable<T>) => string = (v) => `${v}`
): string {
  return isMissingDetailValue(value) ? DETAIL_PLACEHOLDER : format(value as NonNullable<T>);
}
